import { AxiosResponse } from "axios";
import {
  AutocompleteElement,
  FormContainer,
  useForm,
} from "react-hook-form-mui";
import { useTranslation } from "react-i18next";
import HorizontalVerticalTogglerLayout from "src/shared/Layouts/HorizontalVerticalTogglerLayout";
import { TMailBoxFilterValues, TMailBoxParams } from "../../types";
import { Box, Button } from "@mui/material";
import CustomDatePicker from "src/shared/components/CustomDatePicker";

type TMailBoxFilters = {
  mailboxParams: AxiosResponse<TMailBoxParams> | undefined;
  isLoadingParams: boolean;
  setFilters: React.Dispatch<React.SetStateAction<TMailBoxFilterValues>>;
};
function MailBoxFilters(props: TMailBoxFilters) {
  const { t } = useTranslation();
  const { mailboxParams, isLoadingParams: isLoading, setFilters } = props;
  const formContext = useForm<TMailBoxFilterValues>();
  const watch = formContext.watch;
  return (
    <FormContainer
      formContext={formContext}
      onSuccess={(data) => {
        setFilters((prev) => ({ ...prev, ...data }));
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <HorizontalVerticalTogglerLayout>
          <CustomDatePicker
            format={"dd/MM/yyyy"}
            sx={{ width: { sm: "100%", md: "25%" } }}
            maxDate={new Date()}
            label={t("Ημ/νία Αποστολής Από")}
            name={"fromDate"}
          />
          <CustomDatePicker
            format={"dd/MM/yyyy"}
            sx={{ width: { sm: "100%", md: "25%" } }}
            maxDate={new Date()}
            label={t("Ημ/νία Αποστολής Έως")}
            name={"toDate"}
          />
          <AutocompleteElement
            autocompleteProps={{
              sx: { width: { sm: "100%", md: "25%" } },
              getOptionLabel: (option) =>
                mailboxParams?.data?.emailTypeList?.find(
                  (item) => item.id === option,
                )?.description || "",
            }}
            label={t("Κατηγορία Μηνύματος")}
            name={"messageTypeId"}
            loading={isLoading}
            options={
              mailboxParams?.data?.emailTypeList?.map((option) => option.id) ||
              []
            }
          />
          <AutocompleteElement
            autocompleteProps={{
              sx: { width: { sm: "100%", md: "25%" } },
              getOptionLabel: (option) => {
                const item = mailboxParams?.data?.emailReadTypeList?.find(
                  (emailType) => emailType.id === option,
                );

                return item ? t(item.description) : "";
              },
            }}
            label={t("Τύπος Μηνύματος")}
            name={"messageReadTypeId"}
            loading={isLoading}
            options={
              mailboxParams?.data?.emailReadTypeList?.map(
                (option) => option.id,
              ) || []
            }
          />
        </HorizontalVerticalTogglerLayout>
        <Button
          sx={{ alignSelf: "start" }}
          disabled={
            !watch("messageTypeId") &&
            !watch("messageReadTypeId") &&
            !watch("fromDate") &&
            !watch("toDate")
          }
          variant="contained"
          type="submit"
        >
          {t("Αναζήτηση")}
        </Button>
      </Box>
    </FormContainer>
  );
}

export default MailBoxFilters;
